// Read helpers over a track from the API, shared by the card and the toolbar.

import type { AchievementTrackProgress } from '@airhead-games/shared/types';

type TrackMilestone = AchievementTrackProgress['milestones'][number];

// A one-time track has a single milestone and no levels to show.
export const isOneTime = (track: AchievementTrackProgress): boolean =>
  track.milestones.length === 1;

export const isTrackComplete = (track: AchievementTrackProgress): boolean =>
  track.nextMilestoneKey === null;

/** The milestone of the level being worked toward (the top one once done). */
export const currentMilestone = (
  track: AchievementTrackProgress
): TrackMilestone => track.milestones[track.level - 1];

/** Progress toward the current milestone, from 0 to 1. */
export const trackProgress = (track: AchievementTrackProgress): number =>
  Math.min(track.value / currentMilestone(track).threshold, 1);
